import React, { useState } from 'react';
import { notifyInfo } from '@nutastic/nutastic-react-app';

const componentClass = 'subscriptionSelector';
const SUB_TYPES = {
    yearly: 'nuStationYearly',
    monthly: 'nuStationMonthly'
}

const SubscriptionSelector = ({ onCancel, onContinue }) => {
    const [selectedOption, setSelectedOption] = useState(null);

    const onContinueClicked = () => {
        if(!selectedOption) {
            notifyInfo('subscriptionSelectorNotif', 'Select an option', 'Please select an option before continuing');
        } else {
            onContinue(selectedOption);
        }
    };

    return <section className={componentClass}>
        <div>
            <h2>Pick Your Payment</h2>
            <p>Our memberships are pretty simple. You can pay once per the year on your own time, or select a monthly payment and cancel anytime.</p>
        </div>
        <div className={`${componentClass}__options mt-5`}>
            <button className={`${componentClass}__option ${selectedOption === SUB_TYPES.monthly ? 'active' : ''}`} onClick={() => setSelectedOption(SUB_TYPES.monthly)}>
                <div><span>$3</span><sup>/ mo.</sup></div>
                <p>Pay monthly for your membership. Cancel anytime.</p>
                { selectedOption === SUB_TYPES.monthly && <i className="fa fa-check"></i> }
            </button>
            <button className={`${componentClass}__option ${selectedOption === SUB_TYPES.yearly ? 'active' : ''}`} onClick={() => setSelectedOption(SUB_TYPES.yearly)}>
                <div><span>$25</span></div>
                <p>Pay once for 12 months of membership. Renew on your own after 12 months.</p>
                { selectedOption === SUB_TYPES.yearly && <i className="fa fa-check"></i> }
            </button>
        </div>
        <div className={`${componentClass}__buttons mt-3`} onClick={onContinueClicked}>
            <button type="submit" className="btn btn-primary btn-block" disabled={!selectedOption}>Continue</button>
        </div>
        { onCancel && <div className="linkTextButton mt-5" onClick={onCancel}>Go Back</div> }
    </section>;
};

export default SubscriptionSelector;
